interface EligibilityLevelIconProps {
    level: string;
    className?: string;
}

const EligibilityLevelIcon: React.FC<EligibilityLevelIconProps> = ({ level, className = "" }) => {
    // Helper function to get CSS class for eligibility level
    const getEligibilityLevelClass = (level: string): string => {
        switch (level.toUpperCase()) {
            case 'GENERAL': return 'general';
            case 'ITEMS': return 'items';
            case 'ORDER': return 'order';
            case 'CUSTOMER': return 'customer';
            case 'RMA': return 'rma';
            default: return 'default';
        }
    };

    return (
        <span className={`eligibility-level-icon ${getEligibilityLevelClass(level)} ${className}`}>
        </span>
    );
};

export default EligibilityLevelIcon;
